export default {
  "brand": "USFans Spreadsheet",
  "nav.spreadsheet": "Arkusz",
  "nav.guides": "Poradniki",
  "nav.reviews": "Opinie",
  "nav.shipping": "Wysyłka",
  "nav.comparisons": "Porównania",
  "nav.safety": "Bezpieczeństwo",
  "nav.categories": "Kategorie",
  "nav.resources": "Zasoby",
  "nav.home": "Strona główna",
  "nav.buyingGuide": "Poradnik zakupowy",
  "lang.label": "Język",
  "cta.explore": "Poznaj USFans Spreadsheet",
  "cta.buyNow": "Kup teraz",
  "cta.viewAll": "Zobacz wszystkie poradniki",
  "cta.readMore": "Czytaj poradnik",
  "cta.visitStore": "Odwiedź sklep",
  "article.notFound": "Nie znaleziono artykułu",
  "article.backHome": "Wróć do strony głównej",
  "article.faqTitle": "Często zadawane pytania",
  "article.relatedTitle": "Powiązane poradniki",
  "article.ctaTitle": "Kontynuuj badania",
  "article.ctaText": "Poznaj więcej poradników lub odwiedź sklep, aby wykorzystać swoje badania.",
  "footer.about": "Niezależne centrum zasobów do badania USFans Spreadsheet, poradników, porównań, informacji o wysyłce i wskazówek dotyczących bezpieczeństwa.",
  "footer.guides": "Poradniki",
  "footer.company": "Firma",
  "footer.resources": "Zasoby",
  "footer.legal": "Informacje prawne",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Ta strona jest niezależnym źródłem informacji. Informacje mogą się zmieniać w czasie. Zawsze weryfikuj ważne szczegóły przed dokonaniem zakupu lub udostępnieniem danych osobowych."
};